import { CommonModule } from '@angular/common';
import { Component, inject, NgZone, OnInit, signal } from '@angular/core';
import { DiplomaCert, UserProfile } from '@app/core/models';
import { DeviceDetectService } from '@app/core/services';
import { AuthSessionService } from '@app/core/services/auth-session/auth-session.service';
import { DiplomaService } from '@app/core/services/diploma/diploma.service';
import { ModalComponent } from '@app/core/services/modal-manager/modal-component';
import { StorageDocumentsService } from '@app/core/services/storage-documents/storage-documents.service';
import { SharedModule } from '@app/shared/shared.module';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { TranslateModule } from '@ngx-translate/core';
import html2canvas from 'html2canvas';
declare const window: any;

@Component({
  imports: [CommonModule, TranslateModule, SharedModule],
  selector: 'diploma',
  templateUrl: './diploma.component.html',
  styleUrls: ['./diploma.component.scss'],
  standalone: true,
})
export class DiplomaComponent extends ModalComponent implements OnInit {
  protected readonly generatingDiploma = signal(true);
  protected readonly afterIOS = signal(false);
  protected currentUser?: UserProfile;
  protected cert?: DiplomaCert;
  protected expires?: string;
  protected readonly diplomaService = inject(DiplomaService);
  private readonly socialSharing = inject(SocialSharing);
  private readonly zone = inject(NgZone);
  private readonly authSessionService = inject(AuthSessionService);
  private readonly storageDocumentsService = inject(StorageDocumentsService);
  private readonly deviceDetectService = inject(DeviceDetectService);

  constructor() {
    super();
    this.currentUser = this.authSessionService.currentUserProfile;
  }
  ngOnInit(): void {
    this.cert = this.extraData as DiplomaCert;
    this.diplomaService.getExpireDate().subscribe((date) => {
      this.expires = date;
      setTimeout(() => {
        this.downloadDiploma();
      }, 500);
    });
  }

  downloadDiploma(): void {
    const container = document.getElementById('diploma-container');
    if (!container) {
      return;
    }

    // init html2canvas
    setTimeout(() => {
      html2canvas(container, {
        useCORS: true,
        scale: 4,
      }).then((canvas) => {
        // this.modalService.dismissAll();
        // let url: any;
        // if (environment.needD7) {
        //   url = `https://www.ikointl.com/member-public-detail?uid=${this.currentUser?.uid}`;
        // } else {
        //   url = `https://next.ikointl.com/members/${this.currentUser?.name}`;
        // }

        // const imageBase64 = canvas.toDataURL('image/png');
        this.generatingDiploma.set(false);
        // this.socialSharing
        //   .share(
        //     `${DrupalConstants.Connection.current_user.name} ${this.cert?.training_level} IKO Diploma`,
        //     `Check my ${this.cert?.training_level} IKO Diploma`,
        //     imageBase64,
        //     url
        //   )
        //   .then((response) => console.log('Share response:', response))
        //   .finally(() =>
        //this.zone.run(() => {
        // browser download in case if filesharing was not available
        // if (!this.deviceDetectService.isCordova) {
        canvas.toBlob((blob: any) => {
          if (!this.deviceDetectService.isCordova) {
            this.storageDocumentsService.downloadBrowserFromLink(
              window.URL?.createObjectURL(blob as Blob),
              `${this.cert?.training_level}_diploma.png`
            );
            this.dismiss();
          } else {
            this.storageDocumentsService
              .downloadFile(window.URL?.createObjectURL(blob as Blob), `${this.cert?.training_level}_diploma.png`)
              .subscribe({
                complete: () => {
                  if (this.deviceDetectService.isIOS) {
                    this.afterIOS.set(true);
                    setTimeout(() => this.dismiss(), 5000);
                  } else {
                    this.dismiss();
                  }
                },
              });
          }
        });
        // } else {
        //   this.dismiss();
        // }
      });
      // );
      // });
    }, 100);
  }
}
